<template lang="pug">
v-menu(
  v-model="menu",
  :close-on-content-click="false"
  offset-y,
)
  template(v-slot:activator="{ on, attrs }")
    v-list.pa-0(dense, flat, color="background")
      v-list-item(style="min-height: 56px; max-height: 56px;", two-line, dense, v-on="on", data-cy="profile__menu")
        v-list-item-avatar.white--text(tile, color="primary", size="30") {{ initials }}
        v-list-item-content.text-center(style="width: min-content;")
          v-list-item-title.h6.text--text(style="font-weight: 400;") {{ fullName }}
          v-list-item-subtitle.h11.text--text(style="font-size: 9px; font-weight: 800;") {{$scope()}}
        v-list-item-action.ml-2
          v-icon mdi-chevron-down
  profile-card(:loadingBS="loading", v-bind="{ initials, fullName, businessScopes }")
</template>

<script>
import axios from 'axios';

export default {
  data: () => ({
    menu: false,
    loading: false,
    businessScopes: [],
  }),
  watch: {
    menu(val) {
      if (val) this.loadBusinessScopes();
    },
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    fullName() {
      return this.user && this.user.fullName;
    },
    initials() {
      if(_.isEmpty(this.user)) return '';
      return `${(this.user.name || '').charAt(0) || ''}${(this.user.lastName || '').charAt(0) || ''}`
    },
  },
  methods: {
    async loadBusinessScopes() {
      try {
        this.loading = true;
        ({ data: { data: this.businessScopes } } = await axios.get(`UserRoleBusinessScopes`,
        { params: { withoutGlobalBusinessScope: true, load: ['Role'], where: [`x => x.userId =="${this.$store.state.user.user.id}"`], pageSize: -1 } }));
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
